(function ($) {

    $(document).ready(function () {
        $(".click-to-listen-btn").on("click", function () {

            let target = $(this).closest("[data-id]");
            let itemId = target.data("id");
            let targetSection =  $(".featured-podcast");
            let featuredItemId = targetSection.find(".-featured").data("id");

            if( itemId === featuredItemId ) {
                handleFeaturedPodcast(targetSection, featuredItemId)
            } else {
                handleEpisodes(targetSection, itemId);
            }
 
            if( !targetSection.find(".other-podcasts .podcast-wrap").hasClass("-active") ) {
                //if all other podcast is hide then show featured podcast
                targetSection.find(".-featured").removeClass("hide");
                $(".podcast-episodes .podcast").removeClass("hidden");
                $(".podcast-episodes .podcast[data-id='"+ featuredItemId +"']").addClass("hidden");
            } else {
                //stop featured podcasts
                targetSection.find(".-featured").find(".play-btn.hide").trigger("click");
                $(".podcast-episodes .podcast[data-id='"+ featuredItemId +"']").removeClass("hidden");
            }
            //stop other podcasts
            targetSection.find(".other-podcasts").find(".play-btn.hide").trigger("click");


            $("html, body").animate({
                scrollTop: targetSection.offset().top - 85
            }, 300);

        });

        function handleEpisodes(targetSection, itemId) {
            //reset other podcasts
            $(".podcast-episodes .podcast").removeClass("hidden");

            //hide featured podcast
            targetSection.find(".-featured").addClass("hide");
            //hide current podcast from other list
            $(".podcast-episodes .podcast[data-id='"+ itemId +"']").addClass("hidden");

            //show other podcast
            targetSection.find(".other-podcasts .podcast-wrap[data-id='" + itemId + "']").prevAll().removeClass("-active");
            targetSection.find(".other-podcasts .podcast-wrap[data-id='" + itemId + "']").nextAll().removeClass("-active");
            targetSection.find(".other-podcasts .podcast-wrap[data-id='" + itemId + "']").toggleClass("-active");
        }

        function handleFeaturedPodcast(targetSection, featuredItemId) {
            targetSection.find(".other-podcasts .podcast-wrap").removeClass("-active");
            $(".podcast-episodes .podcast").addClass("hidden");
            $(".podcast-episodes .podcast[data-id='"+ featuredItemId +"']").addClass("hidden");
            targetSection.find(".-featured").removeClass("hide");
        }
    });

})(jQuery);